export const options = [
  {
    label: "Completed",
    value: "completed",
    type: "radio",
    // checked:
    //   (projectCompletionDTO &&
    //     /Construction/gi.test(projectCompletionDTO.status)) ||
    //   false,
    name: "statusfields"
  },
  {
    label: "Not Completed",
    value: "notCompleted",
    // checked:
    //   (projectCompletionDTO &&
    //     /partially/gi.test(projectCompletionDTO.status)) ||
    //   false,
    type: "radio",
    name: "statusfields"
  }
];

export const integer_to_roman = num => {
  if (typeof num !== "number") return false;

  let digits = String(+num).split(""),
    key = [
      "",
      "C",
      "CC",
      "CCC",
      "CD",
      "D",
      "DC",
      "DCC",
      "DCCC",
      "CM",
      "",
      "X",
      "XX",
      "XXX",
      "XL",
      "L",
      "LX",
      "LXX",
      "LXXX",
      "XC",
      "",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX"
    ],
    roman_num = "",
    i = 3;
  while (i--) roman_num = (key[+digits.pop() + i * 10] || "") + roman_num;
  return Array(+digits.join("") + 1).join("M") + roman_num;
};

export const DEPENDENT_TYPE = {
  INDEPENDENT: "INDEPENDENT",
  FINISH_TO_START: "FINISH TO START",
  START_TO_START: "START TO START",
  FINISH_TO_FINISH: "FINISH TO FINISH",
  START_TO_FINISH: "START TO FINISH"
};

export const DETAILS_DEPENDENT_TYPE = {
  INDEPENDENT: "Independent",
  FINISH_TO_START: "Finish to Start",
  START_TO_START: "Start to Start",
  FINISH_TO_FINISH: "Finish to Finish",
  START_TO_FINISH: "Start to Finish"
};

export const dependencyDescription = (
  depType,
  milestoneName,
  dependentOnName
) => {
  switch (depType) {
    case "START_TO_START":
      return `'${milestoneName}' can only start when '${dependentOnName}' has started`;
    case "FINISH_TO_START":
      return `'${milestoneName}' can only start when '${dependentOnName}' has finished`;
    case "START_TO_FINISH":
      return `'${milestoneName}' can only finish when '${dependentOnName}' has started`;
    case "FINISH_TO_FINISH":
      return `'${milestoneName}' can only finish when '${dependentOnName}' has finished`;
    default:
      return `'${milestoneName}' is executed independently`;
  }
};

// const data = {
//   bucketMilestoneCOS: [
//     {
//       bucketId: 0,
//       completed: true,
//       disabled: true,
//       milestoneTableDataCOS: [
//         {
//           milestoneDataCOS: [
//             {
//               completed: true,
//               dependencyType: "INDEPENDENT",
//               dependentOnId: 0,
//               milestone: {
//                 id: 0,
//                 name: "string"
//               },
//               originalScheduledFinishDate: "2021-10-05T05:01:05.387Z",
//               originalScheduledStartDate: "2021-10-05T05:01:05.387Z",
//               responsibleAuthority: "string",
//               revisedScheduledFinishDate: "2021-10-05T05:01:05.387Z",
//               revisedScheduledStartDate: "2021-10-05T05:01:05.387Z"
//             }
//           ],
//           tableCO: {
//             id: 0,
//             name: "string"
//           },
//           tableIndex: 0
//         }
//       ],
//       originalScheduledFinishDate: "2021-10-05T05:01:05.387Z",
//       originalScheduledStartDate: "2021-10-05T05:01:05.387Z",
//       revisedScheduledFinishDate: "2021-10-05T05:01:05.387Z",
//       revisedScheduledStartDate: "2021-10-05T05:01:05.387Z"
//     }
//   ]
// };

export const _showMilestoneAction = (
  mainBucket,
  bucketIdx,
  tableIdx,
  milestoneIdx
) => {
  let checkMilestoneFields = {};
  let isMilestoneDataExists = false;
  checkMilestoneFields =
    !!mainBucket &&
    !!mainBucket[bucketIdx] &&
    !!mainBucket[bucketIdx].milestoneTableDataCOS &&
    !!mainBucket[bucketIdx].milestoneTableDataCOS[tableIdx] &&
    !!mainBucket[bucketIdx].milestoneTableDataCOS[tableIdx].milestoneDataCOS &&
    !!mainBucket[bucketIdx].milestoneTableDataCOS[tableIdx].milestoneDataCOS[
      milestoneIdx
    ] &&
    mainBucket[bucketIdx].milestoneTableDataCOS[tableIdx].milestoneDataCOS[
      milestoneIdx
    ];

  isMilestoneDataExists =
    checkMilestoneFields.completed ||
    !!checkMilestoneFields.dependencyType ||
    !!checkMilestoneFields.dependentOnId ||
    !!checkMilestoneFields.originalScheduledFinishDate ||
    !!checkMilestoneFields.originalScheduledStartDate ||
    !!checkMilestoneFields.reasonForDelay ||
    !!checkMilestoneFields.responsibleAuthorityId ||
    !!checkMilestoneFields.revisedScheduledFinishDate ||
    !!checkMilestoneFields.revisedScheduledStartDate;

  return !isMilestoneDataExists;
};

const min_date = all_dates => {
  let min_dt = all_dates[0];
  let min_dtObj = new Date(all_dates[0]);
  all_dates.forEach(dt => {
    if (new Date(dt) < min_dtObj) {
      min_dt = dt;
      min_dtObj = new Date(dt);
    }
  });
  return min_dt;
};

const max_date = all_dates => {
  let min_dt = all_dates[0];
  let min_dtObj = new Date(all_dates[0]);
  all_dates.forEach(dt => {
    if (new Date(dt) > min_dtObj) {
      min_dt = dt;
      min_dtObj = new Date(dt);
    }
  });
  return min_dt;
};

export const _getMinMaxDates = bucketData => {
  let originalScheduledStartDates = [];
  let revisedScheduledStartDates = [];
  let originalScheduledFinishDates = [];
  let revisedScheduledFinishDates = [];

  bucketData.milestoneTableDataCOS.map(item => {
    item.milestoneDataCOS.map(ms => {
      !!ms.originalScheduledStartDate &&
        originalScheduledStartDates.push(ms.originalScheduledStartDate);
      !!ms.revisedScheduledStartDate &&
        revisedScheduledStartDates.push(ms.revisedScheduledStartDate);
      !!ms.originalScheduledFinishDate &&
        originalScheduledFinishDates.push(ms.originalScheduledFinishDate);
      !!ms.revisedScheduledFinishDate &&
        revisedScheduledFinishDates.push(ms.revisedScheduledFinishDate);
    });
  });
  let minOriginalScheduledStart = min_date(originalScheduledStartDates);
  let minrevisedScheduledStart = min_date(revisedScheduledStartDates);
  let maxOriginalScheduledFinish = max_date(originalScheduledFinishDates);
  let maxRevisedScheduledFinish = max_date(revisedScheduledFinishDates);
  let minMaxObj = {
    minOriginalScheduledStart,
    minrevisedScheduledStart,
    maxOriginalScheduledFinish,
    maxRevisedScheduledFinish
  };
  return minMaxObj;
};
